import React from 'react'
import {Button} from 'antd'
import injectCSS from 'react-jss'

class Animation extends React.Component {
  state = {playing: false, mobileShow: false, hover_count: 0};

  componentDidMount() {
    this.setState({
      instance: window.bodymovin.loadAnimation({
        container: document.getElementById(this.props.id), // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: false,
        path: this.props.src, // the path to the animation json
      }),
      first_play: true
    }, () => {this.state.instance.addEventListener('DOMLoaded', () => this.state.instance.goToAndStop(parseInt(this.props.thumbnailFrame, 10), true))});
  }

  componentWillUnmount() {
    this.state.instance.destroy();
  }

  onMouseMove = () => {
    this.setState({hover: true, hover_count: this.state.hover_count + 1});
    setTimeout(() => {
        this.setState({hover_count: this.state.hover_count - 1});
      if (this.state.hover_count === 0) this.setState({hover: false})
    }, 1000);
  }

  onMouseOut = () => {
    this.setState({hover: false});
  }
  getOpacity() {
    if (this.state.playing) {
      if (this.state.mobileShow) return 0.5;
      if (this.state.hover) return 0.5;
      else return 0;
    } else return 1.0;
  }

  render() {
    return (
      <div style={{position: 'relative', paddingBottom: this.props.padding}}
        onMouseMove={this.onMouseMove} onMouseOut={this.onMouseOut}>
        <div id={this.props.id} style={{...this.props.style, position: 'absolute', width: this.props.width, height: this.props.height}}/>
        <div className={this.props.classes.button}
             style={{opacity: this.getOpacity(), width: this.props.width, height: this.props.height}}
             onClick={() => {
               if (this.state.playing) {
                 if (this.props.isMobile && !this.state.mobileShow) {
                   this.setState({mobileShow: true});
                   setTimeout(() => {
                     this.setState({mobileShow: false})
                   }, 2000);
                 } else {
                   this.state.instance.pause();
                   this.setState({playing: false});
                 }
               } else {
                 if (this.state.first_play) this.state.instance.goToAndPlay(0);
                 else this.state.instance.play();
                 this.setState({playing: true,
                  mobileShow: false,
                  first_play: false,
                hover: false})
               }
             }}
        >
          <Button type="primary" shape="circle" icon={this.state.playing ? "pause" : "caret-right"} size="large"/>
        </div>
      </div>
    )
  }
}

const styles = {
  button: {
    position: 'absolute',
    top: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'opacity 1s'
  }
};

export default injectCSS(styles)(Animation)


// WEBPACK FOOTER //
// ./src/components/animation.js